export default __webpack_public_path__ + "static/354-ecd5c8904331f84652d20d054a0f8b85.gif";